import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04738f5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "empty-selected"
}
const _hoisted_2 = { class: "arrow" }

import Dropdown from './parts/Dropdown.vue';
import { Option, SelectDataManager } from './types';
import { computed, nextTick, ref } from 'vue';
import { popperDropdown } from '@/helpers/popper';
import { outsideClick as vOutsideClick, OutsideClickConfig } from '@/directives/outside-click';
import Mark from '../../mark/Mark.vue';

interface Props {
  dataManager: SelectDataManager;
  modelValue?: Option;
  labelKey?: string;
  idKey?: string;
  dropdownHeight?: number;
  hideEmpty?: boolean;
  disableSearch?: boolean;
  errors?: string|string[];
  searchPlaceholder?: string;
  selectOptionText?: string;
  deselectOptionText?: string;
  noOptionsText?: string,
  disabled?: boolean;
  small?: boolean;
}
interface Emits {
  (e: 'update:modelValue', option: Option): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSelect',
  props: {
    dataManager: null,
    modelValue: null,
    labelKey: { default: 'name' },
    idKey: { default: 'id' },
    dropdownHeight: null,
    hideEmpty: { type: Boolean },
    disableSearch: { type: Boolean },
    errors: null,
    searchPlaceholder: null,
    selectOptionText: null,
    deselectOptionText: null,
    noOptionsText: null,
    disabled: { type: Boolean },
    small: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', option: Option): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { dataManager: SelectDataManager, modelValue?: Option, labelKey: string, idKey: string, dropdownHeight?: number, hideEmpty?: boolean, disableSearch?: boolean, errors?: string|string[], searchPlaceholder?: string, selectOptionText?: string, deselectOptionText?: string, noOptionsText?: string, disabled?: boolean, small?: boolean }





const dropdownRef = ref<InstanceType<typeof Dropdown>|undefined>();
const selectRef = ref<HTMLElement|undefined>();
const dropdownOpen = ref<boolean>(false);

const hasErrors = computed(() => {
  const { errors } = props;
  if (errors) {
    return Array.isArray(errors) ? errors.length > 0 : true;
  }
  return false;
});

function closeDropdown() {
  dropdownOpen.value = false;
}
async function openDropdown() {
  if (props.disabled) return;
  dropdownOpen.value = true;
  await nextTick();
  const dropdown = dropdownRef.value;
  const select = selectRef.value;
  if (dropdown && select) {
    popperDropdown(select, dropdown.$el);
  }
}

function toggleDropdown() {
  if (dropdownOpen.value) {
    closeDropdown();
  } else {
    openDropdown();
  }
}

function onOptionClick(option: Option) {
  emit('update:modelValue', option);
  closeDropdown();
}

const outsideClickConfig = ref<OutsideClickConfig>({
  handler(){
    closeDropdown();
  },
  additionalElements(){
    const dropdown = dropdownRef.value;
    return dropdown ? [dropdown.$el] : [];
  }
})

const selectedIds = computed<any[]>(() => {
  return props.modelValue ? [props.modelValue[props.idKey]] : [];
})


return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["single-select", { small: __props.small }]),
    ref_key: "selectRef",
    ref: selectRef
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["selected-options", {
        'dropdown-open': dropdownOpen.value,
        'has-errors': _unref(hasErrors),
        'disabled': __props.disabled,
      }]),
      onClick: toggleDropdown
    }, [
      (__props.modelValue)
        ? _renderSlot(_ctx.$slots, "selected-option", {
            key: 0,
            value: __props.modelValue
          }, () => [
            _createTextVNode(_toDisplayString(__props.modelValue[__props.labelKey]), 1)
          ])
        : (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "selected-empty", {}, () => [
              _createTextVNode(_toDisplayString(__props.selectOptionText ? __props.selectOptionText : _ctx.$t('components.select.select-option')), 1)
            ])
          ])),
      (_unref(hasErrors))
        ? (_openBlock(), _createBlock(Mark, {
            key: 2,
            class: "mark",
            "tooltip-message": __props.errors
          }, null, 8, ["tooltip-message"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FontAwesomeIcon, {
          icon: dropdownOpen.value ? 'caret-up' : 'caret-down'
        }, null, 8, ["icon"])
      ])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (dropdownOpen.value)
            ? (_openBlock(), _createBlock(Dropdown, {
                key: 0,
                search: !__props.disableSearch,
                ref_key: "dropdownRef",
                ref: dropdownRef,
                class: "dropdown",
                dataManager: __props.dataManager,
                height: __props.dropdownHeight,
                "label-key": __props.labelKey,
                "id-key": __props.idKey,
                onOptionClick: onOptionClick,
                "show-empty-value": !__props.hideEmpty && !!__props.modelValue,
                "selected-ids": _unref(selectedIds),
                "deselect-option-text": __props.deselectOptionText,
                "search-placeholder": __props.searchPlaceholder,
                "no-options-text": __props.noOptionsText
              }, {
                option: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, "option", _normalizeProps(_guardReactiveProps(scope)))
                ]),
                _: 3
              }, 8, ["search", "dataManager", "height", "label-key", "id-key", "show-empty-value", "selected-ids", "deselect-option-text", "search-placeholder", "no-options-text"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 2)), [
    [
      _unref(vOutsideClick),
      outsideClickConfig.value,
      void 0,
      { immediate: true }
    ]
  ])
}
}

})